module.exports = __webpack_public_path__ + "img/image-product-2-thumbnail.5ed54768.jpg";